/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useEffect, useCallback, useState } from 'react';
import { getPageAccessByRole } from '../Service/APIService';
export const AccessContext = createContext();

const AccessProvider = ({ children }) => {
  const [pageAccess, setPageAccess] = useState();

  const getPageAccess = useCallback(async () => {
    const response = await getPageAccessByRole();
    const { result } = response.data;
    const appsAccess = result
      ?.filter((item) => item.appName !== 'CA Portal')
      ?.map(
        ({
          appId,
          appName,
          isReadonly,
          id,
          pageId,
          showInTab,
          tabName,
          viewName,
        }) => ({
          appId,
          appName,
          isReadonly,
          id,
          pageId,
          showInTab,
          tabName,
          viewName,
        })
      );
    setPageAccess(appsAccess);
  }, [getPageAccessByRole]);

  useEffect(() => {
    getPageAccess();
  }, []);

  return (
    <AccessContext.Provider
      value={{ pageAccess, setPageAccess, getPageAccess }}
    >
      {children}
    </AccessContext.Provider>
  );
};
export default AccessProvider;
